import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27a66a10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-background w-screen h-screen" }
const _hoisted_2 = { class: "flex flex-col justify-between" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "pageHeader flex justify-between",
  style: {"margin-top":"5px"}
}, "Schwierigkeiten bei der Zugänglichkeit", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner-m" }, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "title-container" }
const _hoisted_8 = {
  key: 0,
  class: "smallHeader pt-10"
}
const _hoisted_9 = { class: "fragenBlock" }
const _hoisted_10 = {
  class: "smallHeader",
  "data-cy": "accessibility-title"
}
const _hoisted_11 = { class: "mt-1 flex" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2 mr-2 mt-1 w-60" }, "Zugänglichkeit:", -1))
const _hoisted_13 = {
  class: "mt-0 w-80 textBlock",
  "data-cy": "pdf-accessibility"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2 mr-2 mt-1 w-60 flex" }, " Beschreibung: ", -1))
const _hoisted_15 = {
  key: 0,
  class: "textBlock",
  "data-cy": "pdf-accessibility-description"
}
const _hoisted_16 = {
  key: 1,
  class: "textBlock mt-2"
}
const _hoisted_17 = { class: "mt-5 flex" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2 mr-2 mt-3" }, "Fotos:", -1))
const _hoisted_19 = {
  key: 0,
  class: "mt-0",
  "data-cy": "pdf-accessibility-photos"
}
const _hoisted_20 = {
  key: 1,
  class: "mt-3",
  "data-cy": "pdf-accessibility-photos"
}
const _hoisted_21 = {
  key: 2,
  class: "trenner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_PdfImageRow = _resolveComponent("PdfImageRow")!
  const _component_page_bottom = _resolveComponent("page-bottom")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.splitIntoChunks(_ctx.zugaenglichkeiten)), (zugaenglichkeit, index) => {
    return (_openBlock(), _createBlock(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang,
      key: index
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_page_header, {
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            Title: 'Zugänglichkeit'
          }, null, 8, ["ba", "immobilie"]),
          _createElementVNode("div", _hoisted_2, [
            (index === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass([index === 0  ? 'content' : 'content-long'])
            }, [
              _createElementVNode("div", _hoisted_7, [
                (zugaenglichkeit?.[0] == null && index == 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Es sind keine Schwierigkeiten bei der Zugänglichkeit vorhanden"))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(zugaenglichkeit, (zugang, index2) => {
                      return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, _toDisplayString("Schwierigkeit bei der Zugänglichkeit - " + (index * 3 + 1 + index2)), 1),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("span", _hoisted_13, _toDisplayString(zugang.fragenblocks?.[0].frages?.[0].eingabeAuswahlWert), 1)
                          ]),
                          _hoisted_14,
                          (zugang.fragenblocks?.[0].frages?.[1].eingabeText !== '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(zugang.fragenblocks?.[0].frages?.[1].eingabeText), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString('Keine Beschreibung vorhanden'))),
                          _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            (zugang?.fragenblocks?.[0].frages?.[3].eingabeMedien?.[0] != null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createVNode(_component_PdfImageRow, {
                                    imageObjects: _ctx.getImageObjects(zugang, 3)
                                  }, null, 8, ["imageObjects"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_20, " Keine Fotos "))
                          ]),
                          (index2 != zugaenglichkeit.length - 1)
                            ? (_openBlock(), _createElementBlock("hr", _hoisted_21))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
              ])
            ], 2)
          ]),
          _createVNode(_component_page_bottom)
        ])
      ]),
      _: 2
    }, 1032, ["pdf-key"]))
  }), 128))
}